import React, {FC} from 'react';
import './style.scss';
import {pathSuite} from "../../../constants";

interface IPopularMixesCard {
    imageUrl: string,
    name: string,
    description: string,
    onClick: () => void
}

const PopularMixesCard: FC<IPopularMixesCard> = ({
                                                     imageUrl,
                                                     name,
                                                     description,
                                                     onClick
                                                 }) => {
    return (
        <div className="mix-week-popular__card" onClick={onClick}>
            <img className="mix-week-popular__card-img"
                 src={pathSuite + imageUrl}
                 alt="Card"
            />
            <div className="mix-week-popular__card-container">
                <div className="mix-week-popular__card-title
                mix-week-popular__card-text">
                    {name}
                </div>
                <div className="mix-week-popular__card-descr
                mix-week-popular__card-text">
                    {description}
                </div>
            </div>
        </div>
    )
};

export default PopularMixesCard;
